<template>
  <div>
    <el-row
      style="
        background-color: blue;
        height: 50px;
        display: flex;
        align-items: center;
      "
    >
      <el-col :span="4" :offset="1">
        <div
          style="font-weight: bold; font-size: 20px; height: 100%; color: white"
        >
          社会化服务监测
        </div>
      </el-col>
      <el-col :span="4" :offset="15">
        <el-button type="text" icon="el-icon-data-board" @click="dataAnalysis"
          >数据分析</el-button
        >
      </el-col>
    </el-row>
    <div style="margin: 20px 20px 0 20px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card>
            <div>
              <div style="font-weight: bold; font-size: 20px">
                全县-在线农机
              </div>
            </div>
            <div
              style="
                font-weight: bold;
                font-size: 20px;
                color: blue;
                margin-top: 20px;
              "
            >
              {{ zxnj }} 台
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card>
            <div>
              <div style="font-weight: bold; font-size: 20px">
                全县-今日作业面积
              </div>
            </div>
            <div
              style="
                font-weight: bold;
                font-size: 20px;
                color: blue;
                margin-top: 20px;
              "
            >
              {{ jrzymj }} 亩
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card>
            <div>
              <div style="font-weight: bold; font-size: 20px">
                全县-本作业季累计作业面积
              </div>
            </div>
            <div
              style="
                font-weight: bold;
                font-size: 20px;
                color: blue;
                margin-top: 20px;
              "
            >
              {{ bzyjljzymj }} 亩
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card>
            <div>
              <div style="font-weight: bold; font-size: 20px">
                全县-总农机数
              </div>
            </div>
            <div
              style="
                font-weight: bold;
                font-size: 20px;
                color: blue;
                margin-top: 20px;
              "
            >
              {{ znjs }} 台
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-row style="height: 50px; align-items: center">
        <el-card style="margin: 20px 20px 0 20px">
          <el-row :gutter="20">
            <el-col :span="4">
              <div style="font-weight: bold; font-size: 20px; height: 100%">
                农机作业轨迹
              </div>
            </el-col>
            <el-form
              :model="form"
              label-position="left"
              label-width="80px"
              inline
              ref="form"
            >
              <el-col :span="4">
                <el-form-item>
                  <el-date-picker
                    size="mini"
                    v-model="form.year"
                    type="year"
                    format="yyyy"
                    value-format="yyyy"
                    placeholder="选择年"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-select
                    size="mini"
                    v-model="form.seasonId"
                    clearable
                    placeholder="请选择作业季"
                  >
                    <el-option
                      v-for="item in seasonDataOPtions"
                      :key="item.id"
                      :label="item.workSeasonName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-select
                    size="mini"
                    v-model="form.orderContent"
                    clearable
                    placeholder="请选择农事环节"
                  >
                    <el-option
                      v-for="item in linkOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-select
                    size="mini"
                    v-model="form.cropCode"
                    clearable
                    placeholder="请选择作物"
                  >
                    <el-option
                      v-for="item in zuOptions"
                      :key="item.categoryName"
                      :label="item.categoryName"
                      :value="item.categoryName"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-input
                    size="mini"
                    v-model="form.companyName"
                    placeholder="请输入合作社名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                  <el-button
                class="query-btn"
                type="primary"
                @click="machineTrajectoryData"
                >搜索</el-button>
<!--                <el-button-->
<!--                  class="query-btn"-->
<!--                  type="primary"-->
<!--                  @click="clearTest"-->
<!--                >清除</el-button>-->
              </el-col>
            </el-form>
          </el-row>
          <el-row style="margin-top: 20px">
            <el-col>
            <div class="map-container">
              <LeafletMap ref="leafletNjjg"></LeafletMap>
            </div>
            </el-col>
          </el-row>
        </el-card>
      </el-row>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import {
  selectSeasonByAreaCode,
  selectLinkByAreaCode,
  selectHomeworkSituationByAreaCode,
} from "@/api/njjg";
import LeafletMap from "@/views/memberCenter/njjg/LeafletMap";

export default {
  data: () => ({
    ak: window.global.bmKey,
    lon: window.global.view.center[0],
    lat: window.global.view.center[1],
    yearData: "",
    season: "",
    link: "",
    zu: "",
    hzs: "",
    seasonDataOPtions: [],
    linkOptions: [],
    zuOptions: [],
    //上方数据
    zxnj: "",
    jrzymj: "",
    bzyjljzymj: "",
    znjs: "",
    form: {
      year: "",
      seasonId: "",
      orderContent: "",
      cropCode: "",
      companyName: ""
    },
  }),
  computed: {
      ...mapGetters(["topSelectAreacode", 'topSelectAreaname','identityObj']),
  },

  created() {
    this.getLinkOptions();
    this.getData();
    this.getSeasonDataOPtions();
  },

  mounted() {
    //隐藏头部和底部
    let header = document.querySelector(".header");
    let noShow = document.querySelector(".noShow");
    // let homeManage = document.querySelector(".home-manage");
    let footer = document.querySelector(".footer");
    header.style = "display:none";
    footer.style = "display:none";
    noShow.style = "display:none";

    // 初始化轨迹地图数据
    this.machineTrajectoryData();

  },
  beforeUnmount() {
  },
  methods: {
    //加载轨迹点数据
    async machineTrajectoryData() {
        let params = {
          ...this.form
        }
        // 调用子组件方法
        await this.$refs.leafletNjjg.getTrajectoryData(params);
    },
    clearTest () {
      this.$refs.leafletNjjg.clearTrajectoryLine()
    },

    dataAnalysis() {
      window.open(window.location.origin + `#/sjfx`,'_blank', 'noopener');
    },
    getData() {
       //隐藏头部和底部
    let header = document.querySelector(".header");
    console.log('header',header)
    let noShow = document.querySelector(".noShow");

    let footer = document.querySelector(".footer");
    header.style = "display:none";
    footer.style = "display:none";
    noShow.style = "display:none";
      let seasonDate = new Date();
      selectHomeworkSituationByAreaCode({
        type: "1",
        seasonDate: moment(seasonDate).format("YYYY-MM-DD HH:mm:ss"),
      }).then((res) => {
        this.zxnj = res?.data?.zxnj;
        this.jrzymj = res?.data?.jrzymj;
        this.bzyjljzymj = res?.data?.bzyjljzymj;
        this.znjs = res?.data?.znjs;
      });
    },
    //获取作业季
    async getSeasonDataOPtions() {
      selectSeasonByAreaCode().then((res) => {
        this.seasonDataOPtions = res.data;
      });
    },
    //获取作业环节和农作物
    async getLinkOptions() {
      selectLinkByAreaCode().then((res) => {
        if (res.code == 0) {
          this.linkOptions = res.data.jobsType;
          this.zuOptions = res.data.categoryPrices;
        }
      });
    },
    magnify() {},
    reduce() {},
  },
  components: {
    LeafletMap,

  }
};
</script>
<style scoped>
.map-container {
  position: relative;
  width: 100%;
  height: 90vh;
}
/* 自定义遮罩样式 */
::v-deep .BMapGL_Polygon:nth-of-type(1) path:nth-of-type(2) {
  fill-rule: evenodd !important; /* 关键：启用奇偶填充规则 */
}
</style>
